var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  validationCadasterNumber: () => validationCadasterNumber
});
function validationCadasterNumber(cadasterNumber) {
  var pesoPosicion = [13, 15, 12, 5, 4, 17, 9, 21, 3, 7, 1];
  var letraDc = "MQWERTYUIOPASDFGHJKLBZX";
  if (cadasterNumber === void 0 || cadasterNumber === null || cadasterNumber.length !== 20) {
    return false;
  }
  cadasterNumber = cadasterNumber.toUpperCase();
  var cadenaPrimerDC = (cadasterNumber.substring(0, 7) + cadasterNumber.substring(14, 18)).toUpperCase();
  var cadenaSegundoDC = (cadasterNumber.substring(7, 14) + cadasterNumber.substring(14, 18)).toUpperCase();
  var cadenasDC = [cadenaPrimerDC, cadenaSegundoDC];
  var dcCalculado = "";
  cadenasDC.forEach(function(cadena) {
    var sumaDigitos = 0;
    cadena.split("").forEach(function(caracter, posicion) {
      let valorCaracter = caracter;
      if (caracter >= "A" && caracter <= "N") {
        valorCaracter = caracter.charCodeAt() - 64;
      } else if (caracter === "\xD1") {
        valorCaracter = 15;
      } else if (caracter > "N") {
        valorCaracter = caracter.charCodeAt() - 63;
      }
      sumaDigitos = (sumaDigitos + valorCaracter * pesoPosicion[posicion]) % 23;
    });
    dcCalculado += letraDc.charAt(sumaDigitos);
  });
  if (dcCalculado !== cadasterNumber.substring(18, 20)) {
    return false;
  }
  return true;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  validationCadasterNumber
});
